import {
  Flex,
  View,
  tokens,
  HelpButton,
  Typography,
} from "@sapphire-react/core";
import { formatMoney } from "../../utils";
import { DonutChart } from "./DonutChart";

type Props = {
  chartItem: DonutChart;
  currency?: string;
  helpLabel?: string;
  withLegendIndicator?: boolean;
};

export function ChartLegend({
  chartItem,
  currency = "kr",
  helpLabel = "Hjälp!",
  withLegendIndicator = true,
}: Props) {
  const {
    value,
    color,
    legendTitle,
    legendSubtitle,
    contextualHelpContent,
    testId,
    displayLabel,
  } = chartItem;

  return (
    <Flex
      paddingTop={tokens.size.spacing3xs}
      paddingBottom={tokens.size.spacing3xs}
    >
      {withLegendIndicator && color && (
        <View
          width={12}
          height={12}
          backgroundColor={color}
          marginRight={tokens.size.spacing2xs}
          marginTop={5}
        />
      )}
      <Flex flexDirection={"column"} width={"100%"}>
        <Flex justifyContent={"space-between"}>
          <Flex alignItems={"center"}>
            <Typography.Body marginRight={tokens.size.spacing3xs} size={"sm"}>
              {legendTitle}
            </Typography.Body>
            {contextualHelpContent && (
              <HelpButton
                variant={"help"}
                aria-label={helpLabel}
                contentBody={contextualHelpContent}
              />
            )}
          </Flex>
          <Flex alignItems={"center"}>
            <Typography.Body size={"sm"} data-test-id={testId}>
              {displayLabel || typeof value !== "number"
                ? displayLabel
                : (value || value === 0) && formatMoney(value, { currency })}
            </Typography.Body>
          </Flex>
        </Flex>
        <Typography.Body
          size={"xs"}
          data-test-id={`${testId}-perc`}
          UNSAFE_style={{
            color: tokens.color.foregroundOnNeutralSubtle.value,
          }}
        >
          {legendSubtitle}
        </Typography.Body>
      </Flex>
    </Flex>
  );
}
